export const salesData = `**$4.75 million**: David Hammons, *Untitled* (2014) at Hauser and Wirth
$4.5 million: Richard Prince, Harbor Nurse (2003) at Gladstone Gallery
$3.5 million: Yayoi Kusama painting at David Zwirner
$2.64 million: Georg Baselitz, Dresdner Frauen – Die Elbe (1990/2023) at Thaddaeus Ropac

$2.5 million: George Condo, Female Portrait Abstraction (2024) at Hauser and Wirth
$2.4 million: David Normal, Parting Shot (2024) at Crazyology Projects
$2.35 million: David Hammons, Rock Head (2000) at White Cube
$2.3 million: Robert Rauschenberg, Everglade (Borealis) (1990) at Thaddaeus Ropac
$2 million: Keith Haring, Untitled (1984) at Gladstone Gallery
$2 million: Noah Davis painting at David Zwirner
$1.5 million: Jean Dubuffet, Ji la grosse tête (1971) at Gladstone Gallery

$1.5 million: Mark Ryden, Regina Terra (#179) (2024) at Kasmin
$1.5 million: Suzanne Jackson, Triptych for Steven (1974) at Ortuzar
$1.4 million: Ed Clark, Untitled (1986) at Hauser and Wirth
$1.4 million: Lisa Yuskavage painting at David Zwirner
$1.27 million: Georg Baselitz, Die Seine, die Seine, die Seine (2023) at Thaddaeus Ropac

$1.25 million–$1.5 million: Tom Wesselmann work at Almine Rech
$1.15 million: Christine Ay Tjoe, Mischievous Player (2016) at White Cube
$1.1 million: Sturtevant, Flag after Jasper Johns (1967) at Thaddaeus Ropac
$1.1 million: Elizabeth Peyton painting at David Zwirner
$1 million: Ed Clark, Untitled (1986–87) at Hauser and Wirth
$1 million: HR Giger, Necronom / Alien III (1990–2005) at Mai 36 Galerie
$1 million: Sam Gilliam, Whispering Wind (1972) at Pace Gallery
$1 million: Ed Ruscha work at Vedovi Gallery
$1.06 million: Lee Ufan, Response (2024) at Mennour



$973,325: Anish Kapoor, Cobalt Blue to Mipa Blue 5 to Clear (2021) at Lisson Gallery

$900,000: Lee Ufan, Response (2024) at Pace Gallery
$900,000: Elizabeth Peyton painting at David Zwirner
$878,055: Anish Kapoor, Cobalt Blue to Mipa 5 (2024) at Lisson Gallery
$875,000–$950,000: Four Howardena Pindell paintings at Garth Greenan, each
$850,000: Lee Ufan, Response (2024) at Lisson Gallery
$849,000: Anish Kapoor, Untitled Work at Mennour
$825,000: Jaume Plensa, Juana (2022) at Gray
$800,000: Lynne Drexler, Tribute (1963) at White Cube
$795,000: Charles Gaines, Numbers and Trees: Tanzania Series 1, Baobab, Tree #4, Maasai (2024) at Hauser and Wirth

$750,000: Alex Katz, Olivia 3 (2024) at Gladstone Gallery
$750,000: Wangechi Mutu, Nyoka (2022) at Gladstone Gallery
$750,000: Rashid Johnson, Soul Painting “Honey” (2024) at Hauser and Wirth
$750,000: Christina Quarles, And I Moon (2024) at Hauser and Wirth
$750,000: Andy Warhol, Hammer and Sickle (1976) at Thaddaeus Ropac
$735,700: Claude and François-Xavier Lalanne, Centaure (moyen) (1995/2008) at Kasmin
$725,000: Lynne Drexler, Final Flowers (1963) at White Cube
$700,000: Elizabeth Peyton, Two Cats (Hydra) (2009) at Gladstone Gallery
$695,000: Carlos Cruz-Diez, Physichromie 637 (1973) at Continua
$675,000: Sean Scully, Wall Red Pink (2024) at Lisson Gallery
$650,000: Fritz Scholder painting at Garth Greenan
$650,000: Keith Haring, Untitled (Brasil) (1986) at Mennour
$650,000: Stanley Whitney, Blue Conversation (2024) at Galerie Nordenhake
$650,000: Robert Longo, Untitled (F-16 American Jet for Ukraine Ascending) (2024) at Thaddaeus Ropac

$629,000: Anish Kapoor, Oriental Blue to Red (2023) at Mennour
$627,600: Antony Gormley, SUSPECT (2024) at Thaddaeus Ropac
$627,600: Antony Gormley, OPEN STRESS II (2023) at White Cube
$600,000–$800,000: Two Josef Albers paintings at David Zwirner, each
$600,000: Carroll Dunham, Once I Land on Mars (Copied from Grace) (1999) at Gladstone Gallery
$600,000: Nicolas Party painting at Xavier Hufkens
$600,000: Fred Eversley, Untitled (cylindrical lens) (2024) at David Kordansky Gallery
$600,000: Pablo Picasso work on paper at Vedovi Gallery
$600,000: Lisa Yuskavage painting at David Zwirner
$585,000: William Kentridge, Goat (2021) at Hauser and Wirth
$575,000: Fred Tomaselli, A Year in One Day (2024) at James Cohan
$575,000: Avery Singer, Untitled (2024) at Hauser and Wirth
$550,000: Rashid Johnson, God Painting “The Baths” (2024) at David Kordansky Gallery
$550,000: Robert Longo, Untitled (Othello) (2024) at Pace Gallery
$525,000: William Kentridge, There Were No Books (2023) at Goodman Gallery
$525,000: Julie Mehretu, Untitled (1999) at White Cube
$500,000: Lynne Drexler, Contained Waters (1969) at Berry Campbell
$500,000: Joan Snyder work at Canada
$500,000: Jeffrey Gibson, I Can Hear You (2024) at Hauser and Wirth
$500,000: Carmen Herrera, Habana Series #11 (1951) at Lisson Gallery
$471,450: Tracey Emin sculpture Xavier Hufkens, two editions, edit
$454,570: Martha Jungwirth, Ohne Titel, aus der Serie “Francisco de Goya, Stillleben mit Rippen und Lammkopf” (2022) at Thaddaeus Ropac
$450,000: Sonia Gechtoff, Lover’s Feast (1960) at Berry Campbell
$450,000: Yoshitomo Nara, Untitled (2024) at Blum Gallery
$450,000: Yoshitomo Nara, Untitled (2024) at Blum Gallery
$450,000: Jordan Casteel, Nina (2024) at Casey Kaplan
$450,000: Adam Pendleton, Black Dada (B) (2024) at Pace Gallery
$450,000: Emily Kam Kngwarray, Untitled (1992) at Pace Gallery
$450,000: Sylvia Snowden, Clarene Martin (1978–82) at White Cube
$443,982: François-Xavier Lalanne, Requin (petit) (2003/2011) at Kasmin
$443,570: Martha Jungwirth, Ohne Titel, aus der Serie “Australidelphia” (2020) at Thaddaeus Ropac
$443,570: Daniel Richter, Mausefalle des Gewissens (2023) at Thaddaeus Ropac
$440,364: Danh Vo, Untitled (2024) at White Cube
$425,000: Elmgreen & Dragset, The Guardian (2023) at Pace Gallery
$425,000: Richard Artschwager, Exclamation Point (Yellow) (2001) at Sprüth Magers
$400,000: Hélio Oiticica, Untitled (1955) at Lisson Gallery
$400,000: Oscar Murillo painting at David Zwirner
$396,413: Julio Le Parc, Mobile losange doré (2024) at Nara Roesler
$390,000: Ha Chong-hyun, Conjunction 19-84 (2019) at Blum Gallery
$375,000: Firelei Báez, When We Seize to Understand (Premiere Carte Pour L’Introduction A L’Histoire Du Monde) (2024) at Hauser and Wirth
$375,000: Teresita Fernández, Astral Sea 2 (2024) at Lehmann Maupin
$360,000: Qiu Xiaofei painting at Xavier Hufkens
$350,000–$400,000: Shara Hughes, Orange Groove (2024) at David Kordansky Gallery
$350,000–$400,000: Alighiero Boetti, Aerei (1988) at Tornabuoni Art
$350,000: Jennifer Guidi, Activated Light (Painted Pink Sand, Multicolored CS, Rainbow Border, Black Ground)(2023) at Massimo De Carlo
$350,000: Sheila Hicks, Truth and Consequences (2024) at Galerie Frank Elbaz
$350,000: Two Paul Feeley at Garth Greenan, each
$350,000: Hajime Sorayama work at Nanzuka
$350,000: David Salle, New Pastoral, Floral Dress (2024) at Thaddaeus Ropac
$327,210: Martha Jungwirth, Ohne Titel (2022) at Thaddaeus Ropac
$325,000: Ken Price work at Xavier Hufkens
$325,000: John Baldessari, Vertical Series: Fun. (2003) at Sprüth Magers
$325,000: Howardena Pindell, Deep Sea #3 (2024) at White Cube
$320,000: Lesley Vance, Untitled (2024) at David Kordansky Gallery
$317,130: Tony Cragg, Incident Upwards (2022) at Lisson Gallery
$300,000: Ai Weiwei, Pillar (2006) at Continua
$300,000–$400,000: Sheila Hicks, Bir Ma’ (Wishing Well) (1970) at Galerie Frank Elbaz
$50,000–$300,000: Four Cannupa Hanska Luger sculptures at Garth Greenan, each
$300,000: Andy Warhol, Mrs. Vardinoyannis (1983-84) at Kasmin
$300,000: Ed Ruscha, Merc Montclair (1994) at Pace Gallery
$300,000: Etel Adnan, Untitled (2020) at White Cube
$290,000: Roberto Matta, Ecce Fumo (1973) at Cardi Gallery
$280,000: Chiachio & Giannone, La Famille dans la Joyeuse Verdure (2013–2019) at Ruth Benzacar Galería de Arte
$275,000: Salvo, Untitled Painting at Gladstone Gallery
$275,000: Mildred Thompson, Radiation Explorations (1994) at Galerie Lelong and Co.
$274,846: Jannis Kounellis, Untitled (1986) at Galerie Lelong and Co.
$264,275: Anne Imhof, Untitled (1pm) (2024) at Sprüth Magers
$252,000: Anish Kapoor, Untitled Work at Mennour
$250,000–$300,000: Robert Mapplethorpe, American Flag (1977) at Gladstone Gallery, two editions, each
$250,000–$390,000: Two Ha Chong Hyun paintings at Tina Kim Gallery, each
$250,000: Paul McCarthy work on paper at Xavier Hufkens
$250,000: Nari Ward, Still Livin’ Streamin’ (2024) at Lehmann Maupin
$250,000: McArthur Binion, DNA: Self Portrait (2024) at Lehmann Maupin
$250,000: Teresita Fernández, Silver Screen/30 Dissolves (2011) at Lehmann Maupin
$250,000: Sean Scully, Small Cubed 10 (2021) at Lisson Gallery
$250,000: Adolph Gottlieb, Imaginary Landscape (1955) at Pace Gallery
$250,000: Wolfgang Tillmans abstract photograph at David Zwirner
$243,133: Javier Calleja work at Nanzuka
$225,000–$250,000: Liza Lou, each hung bells (2024) at Lehmann Maupin
$225,000: Josiah McElheny, From the Library of Doubles V (2025) at James Cohan
$225,000: Emmi Whitehorse painting at Garth Greenan
$225,000: Hilary Pecis, Front Side, Back Side (2024) at David Kordansky Gallery
$225,000: Kiki Smith, Siren (2019) at Galleria Lorcan O’Neill
$225,000: Tara Donovan, Stratagem XVI (2024) at Pace Gallery
$220,000: Jordan Nassar, Song of the Flowers (2022) at James Cohan
$220,000: Three Andra Ursuța sculptures at David Zwirner, each
$215,000: Thornton Dial, Struggling Picture (Mighty Few Try to Make It to the Top) (1991) at Edel Assanti
$211,420: Kiki Smith, Her (2003) at Galerie Lelong and Co.
$200,000–$250,000: Lucy Bull, 15:15 (2024) at David Kordansky Gallery
$200,000–$250,000: Adam Pendleton, Untitled (Days) (2023) at David Kordansky Gallery
$200,000: Elias Sime, Tightrope: Split in Half (2017) at James Cohan
$200,000: Michelangelo Pistoletto, Color and Light (2023) at Continua
$200,000: Robert Mapplethorpe, American Flag (1977) at Gladstone Gallery, two editions, each
$200,000: Catherine Goodman, Scarlet Shig (2023) at Hauser and Wirth
$200,000: Thomas Houseago sculpture at Xavier Hufkens, three editions, each
$200,000: Marilyn Minter, Left On Red (2024) at Lehmann Maupin
$200,000: Nari Ward, Restin’ Break (2024) at Lehmann Maupin
$198,168: Ben Sledsens, Hidden Campfire (2024) at Tim Van Laere Gallery
$197,000: Annie Morris sculpture at Timothy Taylor
$195,000: Robert Indiana, ART (Red Blue) (1972–2000) at Pace Gallery
$190,000: Ugo Rondinone, fünfzehnternovemberzweitausendvierundzwanzig (2024) at Gladstone Gallery
$190,000: Lee Bul, Perdu CCI (2024) at Lehmann Maupin
$190,000: Tom Sachs, Portrait de Dora Maar (2024) at Thaddaeus Ropac
$188,600–$282,900: Yinka Shonibare, bronze sculptures and quilts at Goodman Gallery
$185,000: Jonathan Gardner, Drama Club (2024) at Massimo De Carlo
$185,000: Nairy Baghramian, Treat (2016) at Hauser and Wirth
$185,000: Robert Nava, Forgiveness Swan (2024) at Night Gallery
$180,000–$200,000: Larry Poons work at Almine Rech
$180,000: Early Carrie Mae Weems work at Goodman Gallery
$180,000: Teresita Fernández, Stella Maris (Net) 10 (2024) at Lehmann Maupin
$180,000: Teresita Fernández, Stella Maris (Net) 8 (2024) at Lehmann Maupin
$180,000: Hélio Oiticica, Untitled (1958) at Lisson Gallery
$180,000: Hilary Pecis painting at Timothy Taylor
$180,000: Katherine Bernhardt painting at David Zwirner
$175,000–$200,000: Lee Bae, Issu du feu-27cd (2004) at Perrotin
$175,000: Yoan Capote, Isla (umbra) (2024) at Continua
$175,000: Rob Pruitt, A Month of Sunsets (December 2023) (2024) at Massimo De Carlo
$175,000: Elizabeth Peyton, Untitled Drawing at Gladstone Gallery
$175,000: Allison Katz, Big Cat (2024) at Hauser and Wirth
$175,000: Michal Rovner, Glass Flowers II (2024) at Pace Gallery
$175,000: Kara Walker, Selkie with her Skin on (2024) at Sprüth Magers
$175,000: Ilana Savdie, Revenge Fantasies (2024) at White Cube
$170,000: Jenna Gribbon, Paint My Fury (2024) at Massimo De Carlo
$170,000: Paul Jenkins painting at Timothy Taylor
$160,000: María Berrío, Distant Gods and Aging Suns (2024) at Hauser and Wirth
$160,000: Hugh Hayden, Skittles (2024) at Lisson Gallery
$155,000: Joel Mesler, Untitled (Pure Joy) (2024) at David Kordansky Gallery
$155,000: Cinga Samson, Nincede nikhawuleze (2024) at White Cube
$150,000–$200,000: Calida Rawles, I’ll See You On Your Way (2024) at Lehmann Maupin
$150,000: Roberto Matta, Untitled (c. 1990) at Blum Gallery
$150,000: Michaela Yearwood-Dan, Untitled Large-Scale Painting (2024) at Marianne Boesky Gallery
$150,000: Michaela Yearwood-Dan, Untitled Large-Scale Painting (2024) at Marianne Boesky Gallery
$150,000: Sanford Biggers, 3D Quilted Sculpture (2024) at Marianne Boesky Gallery
$150,000: Michaela Yearwood-Dan painting at Marianne Boesky Gallery
$150,000: Michaela Yearwood-Dan painting at Marianne Boesky Gallery
$150,000: Sanford Biggers sculpture at Marianne Boesky Gallery
$150,000: Two Judy Chicago works at Gavlak, combined
$150,000: Jim Hodges, lost to find (2024) at Gladstone Gallery
$150,000: Kudzanai Chiurai work at Goodman Gallery
$150,000: McArthur Binion, self:portrait (2024) at Gray
$150,000: Roger Brown, The Rose Garden (Rosa Rugosa Rubra) (1993) at Gray
$150,000: Michaela Yearwood-Dan, Chimera (2024) at Hauser and Wirth
$150,000: Brian Jungen, Arms Open Wide (2024) at Casey Kaplan
$150,000: Robert Motherwell, The Green Beside the Sea (1966) at Kasmin
$150,000: Sarah Grilo, Nobody Ever… (1966) at Galerie Lelong and Co.
$150,000: Zilia Sánchez, Sin título (2023, conceived 2007–08) at Galerie Lelong and Co.
$150,000: John McCracken, Untitled (1981) at Lisson Gallery
$150,000: Robert Nava, Rose Seal (2024) at Night Gallery
$150,000: Li Songsong, Dragon Year (2024) at Pace Gallery
$150,000: Peter Alexander, 10/13/17 (Blue Black Needle) (2017) at Pace Gallery
$148,000: Carla Accardi, Omaggio a Matisse (1964) at Cardi Gallery
$145,000: Allora & Calzadilla, Pulse (2024) at Galerie Chantal Crousel
$145,000: Rob Pruitt, November 4, 2024 (24 Hours) (2024) at Massimo De Carlo
$145,000: Herbert Gentry, Le Jardin (1960) at Ryan Lee
$140,000: McArthur Binion work at Xavier Hufkens
$140,000: Park Seo-Bo, Ecriture No.221107 (2022) at White Cube
$135,000: Jim Hodges, That point of contact (2024) at Gladstone Gallery
$130,000–$150,000: Nathaniel Mary Quinn work at Almine Rech
$130,000: Clare Woods, Time Slip (2024) at Night Gallery
$127,000: Two Latifa Echakhch at Kaufmann Repetto, each
$126,000: Julieta Tarraubella, The Secret Life of Flowers | Garden (2024) at Rolf Art
$125,000: Aaron Garber-Maikovska, Off Ramps Corner Play And Avenues (2024) at Blum Gallery
$125,000: Ghada Amer, Untitled Large-Scale Painting (2024) at Marianne Boesky Gallery
$125,000: Ghada Amer painting at Marianne Boesky Gallery
$125,000: Trenton Doyle Hancock, Step and Screw: Eureka! (2024) at James Cohan
$125,000: Trenton Doyle Hancock, Line Up Featuring Torpedoboy and TDH Properties (2021) at James Cohan
$125,000: Cecily Brown monotype at Gavlak
$125,000: David Salle, New Pastoral 22 (2024) at Gladstone Gallery
$125,000: David Salle, New Pastoral Red Blanket (2024) at Gladstone Gallery
$125,000: David Salle, New Pastoral Turquoise (2024) at Gladstone Gallery
$125,000: Jaume Plensa, Hortense in Slumberland (2021) at Gray
$125,000: Jaume Plensa, Juana’s Frozen Dreams (2021) at Gray
$125,000: Lita Albuquerque, She has shifted scales on the planet, so can we see (2021) at Michael Kohn Gallery
$125,000: Joel Mesler, Untitled (Joy Hope) (2024) at David Kordansky Gallery
$125,000: Nari Ward, Medicine Bats (Blue) (2024) at Lehmann Maupin, two editions, each
$125,000: Hayley Barker, Valentine Path Full Moon, Morning (2024) at Night Gallery
$125,000: Leo Villareal, Golden Game (2024) at Pace Gallery
$125,000: Eddie Martinez painting at Timothy Taylor
$125,000: Friedrich Kunath, At My Age, I Need Serenity (2024) at Tim Van Laere Gallery
$120,000: Nick Mauss, Its Aftermath is Smoke (2022) at Galerie Chantal Crousel
$120,000: Jennifer Steinkamp, Botanic 1 (2015) at Lehmann Maupin
$110,000–$120,000: Billie Zangewa, A Charmed Life (2024) at Lehmann Maupin
$120,000: Tunga, Untitled (Steel Pod Series) (2013) at Lisson Gallery
$120,000: Mika Tajima, Art d’Ameublement (Oparo Island) (2024) at Pace Gallery
$120,000: Alberto Biasi, Tutti si muovono con te 9 (2021) at Tornabuoni Art
$116,300: Günther Förg, Untitled (2005) at Hauser and Wirth
$116,300: Two Mark Manders sculptures at Xavier Hufkens, each
$116,281: Jaume Plensa, LUCILLA’S FROZEN DREAMS (2021) at Galerie Lelong and Co.
$116,281: Jaume Plensa, LUCILLA’S FROZEN DREAMS (2021) at Galerie Lelong and Co.
$116,281: Leiko Ikemura, Peace in Spring (2020) at Lisson Gallery
$116,000: Three Ugo Rondinone works at Mennour, each
$115,000: Sayre Gomez painting at Xavier Hufkens
$115,000: Jamie Nares, Make it a Thing (2024) at Kasmin
$110,000: Guillermo Garcia Cruz sculpture at Piero Atchugarry
$110,000: Suzanne McClelland painting at Marianne Boesky Gallery
$110,000: Mohamed Sami work at Luhring Augustine
$110,000: Kylie Manning, Hold the Earth Above Me (2024) at Pace Gallery
$110,000: Nigel Cooke, Rosa’s Version (2024) at Pace Gallery
$110,000: Carlito Carvalhosa, Untitled (P53/20) (2020) at Nara Roesler, three pieces, each
$110,000: Sean Landers painting at Timothy Taylor
$110,000: Diedrick Brackens, birth of humility (2024) at Various Small Fires
$105,000: Friedrich Kunath, I Tried To Make It Last (2024) at Blum Gallery
$100,000–$450,000: Multiple Raymond Pettibon works at David Zwirner, each
$100,000–$125,000: Daniel Arsham, The Discovery of the Eroded Head of Zeus and the Bust of Flora (2024) at Perrotin
$100,000–$120,000: Archmanoro Niles, Whoever Said Time Heals Everything Still Feels Like a Lie (Maybe 13 Was too Early Maybe 34 is too) (2024) at Lehmann Maupin
$100,000–$120,000: Jason Boyd Kinsella, Christophe (2024) at Perrotin
$100,000–$120,000: Jason Boyd Kinsella, Live (2024) at Perrotin
$100,000–$120,000: Bernard Frize, Raste (2024) at Perrotin
$100,000: Alex Katz, Study for Purple Flowers (2024) at Gladstone Gallery
$100,000: Alex Katz, Study for White Flowers (2024) at Gladstone Gallery
$100,000: Maureen Gallace, Sandy Path (2024) at Gladstone Gallery
$100,000: Alex Katz, Study for Autumn 2 (2022) at Gray
$100,000: Alex Katz, Study for Autumn 30 (2022) at Gray
$100,000: UMAN, Red (2024) at Hauser and Wirth
$100,000: Katherine Bradford work at Kaufmann Repetto
$100,000: Evan Holloway, Eyes Open (2019) at David Kordansky Gallery
$100,000: Hiroshi Sugimoto, Sea of Buddha 007 (1995) at Lisson Gallery
$100,000: Daniel Senise, Untitled (Capela Sistina) (2024) at Nara Roesler
$100,000: Phoebe Boswell painting at Wentrup
$100,000: Julie Curtiss, Mary with the Medela (2024) at White Cube
$95,190: Martha Jungwirth, Ohne Titel (2021) at Thaddaeus Ropac
$95,000-$150,000: Franz Kline paintings at Hirschl and Adler, each
$95,000: Eamon Ore-Giron, Infinite Regress CLIV (Variation I) (2024) at James Cohan
$95,000: Eamon Ore-Giro, Infinite Regress CLXXXVI (Variation I) (2024) at James Cohan
$95,000: Marisa Adesman, June Drop (2024) at Anat Ebgi
$95,000: Leonardo Drew work at Goodman Gallery
$95,000: Igshaan Adams, Faroll, Buddy, Dustin, Manon-Lee, Georgia, Esmé, Byron i (2024) at Casey Kaplan
$95,000: Torkwase Dyson, Undrowned 2 (Bird and Lava) (2024) at Pace Gallery
$95,000: Beverly Fishman, Independence, Fitness, Relaxation, Energy, Confidence, Peace (2024) at Jessica Silverman
$95,000: Louise Lawler, Three Flags (swiped and moving) (2022) at Sprüth Magers
$92,000: Svenja Deininger painting at Marianne Boesky Gallery
$90,000: Svenja Deininger painting at Marianne Boesky Gallery
$90,000: Sheila Hicks, Hesitation is a Sign of Intelligence (2023) at Galerie Frank Elbaz
$90,000: Nir Hod, 100 Years is Not Enough (2024) at Michael Kohn Gallery
$90,000: Nari Ward, Still Livin’ Evermore (2024) at Lehmann Maupin
$90,000: Tammy Nguyen, Tango, Tango, Pious Woman (2024) at Lehmann Maupin
$90,000: Tammy Nguyen, Sierra, Lima, Pious Woman (2024) at Lehmann Maupin
$90,000: Alicja Kwade, Principium (2023) at Mennour
$90,000: Joan Snyder, Linen & Lace (2022–23) at Thaddaeus Ropac
$90,000: Robert Longo, Study of Hanging Wisteria (2024) at Thaddaeus Ropac
$89,900: Katie Paterson, Evergreen (2022) at James Cohan
$88,000: Two Keiichi Tanaami works at Nanzuka, each
$85,000–$100,000: Alejandro Cardenas work at Almine Rech
$85,000: Tom Anholt, Night Fishing (2024) at Blum Gallery
$85,000: Sebastian Silva, Untitled (2024) at Blum Gallery
$85,000: Eileen Agar, Still Life (1964) at Andrew Kreps
$85,000: Zilia Sánchez, Lunar Blanco (2019, conceived 2000) at Galerie Lelong and Co.
$85,000: Dhewadi Hadjab, Untitled (2024) at Mennour
$85,000: Elena Damiani, Testigos II (after A. Aalto) (2024) at Galerie Nordenhake
$85,000: Irving Penn, Gisele Reading (A), New York (2006) at Pace Gallery
$85,000: Analia Saban, Woven Radial Gradient as Weft (Center, Cadmium Yellow Medium) (2024) at Sprüth Magers
$84,569: Leiko Ikemura, Pink Sky (2019) at Lisson Gallery
$82,570: Rinus Van De Velde, And When the Cigarette Smoke Slowly but Surely Drifts Away… (2024) at Tim Van Laere Gallery
$80,000–$150,000: Kwon Young Woo work at Tina Kim Gallery
$80,000: Kenjiro Okazaki, Good heavens! What have we here. I’m coming out. The sun shone, the sky was blue, all seemed so lovely and afternoony and summery. And yet, oh horror, she was going to be forced to believe who gave the wind its hues. (2024) at Blum Gallery
$80,000: Eva Jospin, Belvédère (2024) at Continua
$80,000: Ambera Wellmann, Blood’s Hot Walls (2024) at Hauser and Wirth
$80,000: Haroshi work at Nanzuka
$80,000: Loie Hollowell, Spectrum, Cadmium Yellow Deep (2024) at Pace Gallery
$80,000: Paul Anthony Smith painting at Timothy Taylor
$79,283: Juan Uslé, Melting Blue (2024) at Galerie Lelong and Co.
$75,000–$100,000: Kibong Rhee work at Tina Kim Gallery
$75,000–$95,000: Jean-Michel Othoniel, Collier cristal, rose et alessandrita (2024) at Perrotin
$75,000: Yvonne Thomas, High Jack (1963) at Berry Campbell
$75,000: Kaloki Nyamai, Nilika kiwuni ona mwalea II (I will swim even if you refuse) (2024) at James Cohan
$75,000: Torkwase Dyson, Sensoria (2024) at Gray
$75,000: Diana Al-Hadid, Sow Again (2024) at Kasmin
$75,000: Maia Cruz Palileo, Thunder Across the Trail (2024) at David Kordansky Gallery
$75,000: Dominic Chambers, The Zone #2 (2024) at Lehmann Maupin
$75,000: Flavio Garciandía, Suaves desesperos (2010) at Mai 36 Galerie
$75,000: Kiki Smith, Flurry (2016) at Galleria Lorcan O’Neill
$75,000: Alejandro Piñeiro Bello, 500 Years (2024) at Pace Gallery
$75,000: Eduardo Terrazas work at Timothy Taylor
$75,000: Dianna Molzan, Untitled (2024) at Various Small Fires
$74,766: Kati Heck, Der die das, Befehl! (2024) at Tim Van Laere Gallery
$74,320: Erwin Wurm, Mind Bubble Standing Small (2024) at Thaddaeus Ropac
$72,000: Claire Tabouret, Seated Bather (color tbd) (2024) at Night Gallery
$72,000: Nevin Aladag sculpture at Wentrup
$70,000–$90,000: Kenjiro Okazaki, The Duck, the Duck, What a Yellow Beak. (2023) at Galerie Frank Elbaz
$70,000–$80,000: Carlos Jacanamijoy work at Almine Rech
$70,000: Janice Biala, Marie Lorraine & Nicole (c. 1958) at Berry Campbell
$70,000: Eamon Ore-Giro, Infinite Regress V (Variation I) (2024) at James Cohan
$70,000: Wade Guyton, Galerie Matthiesen, Ausstellung, Edouard Manet, 1928, 6. Februar bis 18. März, Vol. II, 91 to 99 (2022) at Galerie Chantal Crousel
$70,000: Bosco Sodi, Untitled (2024) at Kasmin
$70,000: Sara Flores, Untitled (Tayan Kené 1, 2024) (2024) at White Cube
$69,000: Francis Picabia, Sans titre (c. 1940) at Mennour
$68,000: Li Hei Di, What Pane of Glass Make Lucid the Reflection? (2024) at Pace Gallery
$65,000: Ryan Sullivan, Untitled (2024) at Blum Gallery
$65,000: Svenja Deininger painting at Marianne Boesky Gallery
$65,000: Eamon Ore-Giro, Infinite Regress CLXXVII (Variation I) (2024) at James Cohan
$65,000: Naudline Pierre, To Become Lovely (2024) at James Cohan
$65,000: Naudline Pierre, To Remain Persistent (2024) at James Cohan
$65,000: Mungo Thomson, Red Wave (2024) at Galerie Frank Elbaz
$65,000: Ian Davenport, Icon No. 3 (2024) at Kasmin
$65,000: Dominic Chambers, Swaying in the Field of Red and Blue (2024) at Lehmann Maupin
$65,000: Michel Pérez Pollo, Tora (2024) at Mai 36 Galerie
$65,000: Ross Caliendo, Untitled (Mirror) (2024) at Night Gallery
$65,000: Jorinde Voigt, Piece for Words and Views II (2012) at David Nolan Gallery
$65,000: Hayal Pozanti, Her Summer Dreams (2024) at Jessica Silverman
$63,400–$121,700: Multiple Kapwani Kiwanga works at Goodman Gallery, each
$63,000: Dianna Molzan work at Kaufmann Repetto
$62,000: Jenny Morgan, Wilderness Escape (2024) at Anat Ebgi
$60,000–$80,000: Robert Peterson painting Gavlak
$60,000–$90,000: Gimhongsok work at Tina Kim Gallery
$60,000–$90,000: Suki Seokyeong Kang work at Tina Kim Gallery
$60,000–$90,000: Lee ShinJa work at Tina Kim Gallery
$60,000: Naudline Pierre, Evening Song (2024) at James Cohan
$60,000: Naudline Pierre, Morning Dance (2024) at James Cohan
$60,000: Lee Jin-Woo, Untitled P 24-075 (2024) at Leeahn
$60,000: Tony Bechara, Quadrant II 130 Colors (2024) at Lisson Gallery
$60,000: Joanna Pousette-Dart, Day for Night (2024) at Lisson Gallery
$60,000: Abraham Palatnik, S-31 (2001) at Nara Roesler
$60,000: Hayal Pozanti sculpture at Timothy Taylor
$58,221: Tal R, Sleeping Emma with Dandelions (2024) at Tim Van Laere Gallery
$58,000: Judith Eisler, BV (2013–2024) at Casey Kaplan
$58,000: Hayal Pozanti, Giddy and Incandescent (2024) at Jessica Silverman
$57,700–$68,300: Gregor Hildebrandt, Ursula Andress Kasten (2024) at Perrotin
$56,000: Jordan Nassar, Whence Four Rivers I-VI (2024) at Anat Ebgi, suite of six embroideries, each
$56,000: Guimi You, Nocturne (2024) at Jessica Silverman
$55,000: Alice Baber, Among (1962) at Berry Campbell
$55,000: Alice Baber, Untitled (c. 1962) at Berry Campbell
$55,000: Celeste Rapone painting at Marianne Boesky Gallery
$55,000: Kelly Sinnapah Mary, The Fables of Sanbras: The New World (2024) at James Cohan
$55,000: Kelly Sinnapah Mary, Notebook of No Return: Alice and Goliath (2019) at James Cohan
$55,000: Kaloki Nyamai, Ndikasyoka vaa inge (2024) at James Cohan
$55,000: Simon Evans and Sarah Lannan, Improvements (2024) at James Cohan
$55,000: Matthew Ronay, Dear Flesh, …Love, Supplicant (2024) at Casey Kaplan
$55,000: Loriel Beltrán, Half Grid Sequence (after Lynne) (2024) at Lehmann Maupin
$55,000: Kelly Akashi, Cultivator (Radiant Stamens) (2023–2024) at Lisson Gallery
$55,000: Vik Muniz, Seated Figure with Hat, after Richard Diebenkorn (2024) at Nara Roesler
$55,000: Beverly Fishman, Composure, Self-Determination, Equanimity, Calm (2024) at Jessica Silverman
$54,971: Leiko Ikemura, Usagi with Wings (2021) at Lisson Gallery
$54,920: Tal R, Abel’s Afternoon (2024) at Tim Van Laere Gallery
$53,000: Davide Balliano, UNTITLED_0299 (2024) at Cardi Gallery
$52,000: Beverly McIver, Daddy is His Blue Checkered Shirt (2024) at Berry Campbell
$52,000: Karyn Lyons, The Insomniacs (2024) at Anat Ebgi
$51,000: Artur Lescher, Cristobal (2024) at Nara Roesler, four of five editions, each
$50,208: Marguerite Humeau, Life in a Pile of Compost II (2024) and Life in a Pile of Compost III (2024) at White Cube, each
$50,000–$100,000: Two Matt Connors paintings at Xavier Hufkens, each
$50,000–$60,000: Zio Ziegler work at Almine Rech
$50,000: Sebastian Silva, Untitled (2024) at Blum Gallery
$50,000: Katherine Bradford work at Canada
$50,000: Loris Cecchini, Moonshade (sq 128) (2023) at Continua
$50,000: Mark Leckey, Windows (2024) at Gladstone Gallery
$50,000: Mark Leckey, Monstrance (2024) at Gladstone Gallery
$50,000: Richard Artschwager work at Xavier Hufkens
$50,000: Todd Gray, Time Warp (Chuck) (2024) at Lehmann Maupin
$50,000: Brie Ruais, Shrouding Me with Her, 130 + 130lbs (2024) at Night Gallery
$50,000: Brie Ruais, Counting Down (Time is a Mother), 130 lbs (2023) at Night Gallery
$50,000: Maria Klabin, Lady and Boy (2024) at Nara Roesler
$50,000: Marco A. Castillo, Aberraciòn II (2023) at Nara Roesler
$50,000: Rupy C. Tut, Bowing to the Cosmos (2024) at Jessica Silverman
$49,000: Wanda Koop, Crescent (2024) at Night Gallery
$49,000: Two Phoebe Boswell pastel drawings at Wentrup, each
$48,500: Ken Gun Min, Revolution is Love (Will You Still Love Me Tomorrow?) (2024) at Nazarian / Curcio
$48,000: Dianna Molzan work at Kaufmann Repetto
$48,000: Julie Buffalohead, Earth People Sky People (2024) at Jessica Silverman
$48,000: Hayal Pozanti painting at Timothy Taylor
$47,569: Kasper Sonne work at Nanzuka
$47,331: Laure Prouvost, Holding On (2024) at Lisson Gallery
$46,512: Koen van den Broek, W Silver Dr (2024) at Gallery Baton
$46,000: Yuichi Hirako, Lost in Thought 220 (2024) at Gallery Baton
$45,000–$100,000: Five Danielle Orchard works at Perrotin, each
$45,000–$50,000: Ugo Rondinone, neunteroktoberzweitausendvierundzwanzig (2024) at Gladstone Gallery
$45,000–$50,000: Ugo Rondinone, achteroktoberzweitausendvierundzwanzig (2024) at Gladstone Gallery
$45,000–$50,000: Ugo Rondinone, zehnteroktoberzweitausendvierundzwanzig (2024) at Gladstone Gallery
$45,000–$50,000: Ugo Rondinone, elfteroktoberzweitausendvierundzwanzig (2024) at Gladstone Gallery
$45,000–$50,000: Ugo Rondinone, zwölfteroktoberzweitausendvierundzwanzig (2024) at Gladstone Gallery
$45,000: Sam Moyer, Clipping 3 (2024) at Blum Gallery
$45,000: Allison Janae Hamilton sculptyre at Marianne Boesky Gallery
$45,000: Jammie Holmes paintingat Marianne Boesky Gallery
$45,000: Four Hannah van Bart paintings (2024) at Marianne Boesky Gallery, each
$45,000: Hannah Levy, Untitled (2024) at Massimo De Carlo
$45,000: Sara Anstis, The Dollmaker (2024) at Kasmin
$45,000: Sam McKinniss, Martha Stewart (2024) at David Kordansky Gallery
$45,000: Uri Aran, Concentration (2016–2023) at Andrew Kreps
$45,000: Elena Alonso, Kind and Sharp (2024) at Fabian Lang and Espacio Valverde
$45,000: Leonardo Drew, Number 394D (2024) at Galerie Lelong and Co.
$45,000: Patricia Treib, Sinuate II (2024) at Galerie Nordenhake
$45,000: Ryan Mrozowski, Untitled (Nocturne) (2024) at Galerie Nordenhake
$45,000: Masako Miki, A Cat Who Lived a Million Times Lights the Universe (2024) at Jessica Silverman
$45,000: Chris Martin painting at Timothy Taylor
$44,000: March Avery, Reclining Red Nudes (2001/2002/2012) at Blum Gallery
$44,000: Ken Gun Min, How Deep Is the Ocean? (2024) at Nazarian / Curcio
$43,000: Bosco Sodi, Untitled (2024) at Kasmin
$43,000: Claire Tabouret, Seated Bather (2021) at Night Gallery
$42,000: Davide Balliano, UNTITLED_0313 (2024) at Cardi Gallery
$42,000: Davina Semo, Offline (2024) at Jessica Silverman
$42,000: Davina Semo, Flow (2024) at Jessica Silverman
$42,000: Pae White, Vowel Group, Blue (2024) at Jessica Silverman
$40,000–$120,000: Two Omar Ba works at Templon, each
$40,000–$90,000: Timo Fahler, I Against I (2024) at Sebastian Gladstone
$40,000–$90,000: Timo Fahler, Code Switching (2024) at Sebastian Gladstone
$40,000–$90,000: Timo Fahler, Twin Serpents (2024) at Sebastian Gladstone
$40,000–$90,000: Timo Fahler, Fever Dream (2024) at Sebastian Gladstone
$40,000–$60,000: Nick Doyle, Hidden Agenda (2024) at Perrotin
$40,000–$60,000: JR, Dans la Caverne, Dé-composition #1 (2024) at Perrotin
$40,000: Christopher Myers, Baramasa (2024) at James Cohan
$40,000: Matthew Brannon, Joan Didion, ‘Democracy, A Novel,’ 1984 (2024) at Casey Kaplan
$40,000: Matthew Brannon, Head Space (2024) at David Kordansky Gallery
$40,000: Matthew Brannon, Speed Queens (2024) at David Kordansky Gallery
$40,000: Tristan Unrau, Rear Guard (2024) at David Kordansky Gallery
$40,000: Kate Shepherd, Kiss Architecture (2024) at Galerie Lelong and Co.
$40,000: Hugh Hayden, To Be Titled (2023) at Lisson Gallery
$40,000: Vian Sora, Fecundity (2024) at David Nolan Gallery
$40,000: Vian Sora, Summer’s Palimpsest (2024) at David Nolan Gallery
$40,000: Paul Fägerskiöld, Isla Santa Cruz, Galapagos Islands, Republic of Ecuador. View East. 1 January 2100. (2023) at Galerie Nordenhake
$40,000: Woody De Othello, Face Value (2024) at Jessica Silverman
$40,000: Hayal Pozanti, Simple Eternities (2024) at Jessica Silverman
$38,000: Suzanne Song, Constant Dawn (2024) at Gallery Baton
$38,000: Dashiell Manley painting (2024) at Marianne Boesky Gallery
$38,000: Soumya Netrabile, Downstream (2024) at Anat Ebgi
$38,000: Johanna Unzueta, Zwischi 2022, Berlin 2023, Zwischi 2023 II (2023) at Casey Kaplan
$38,000: Catherine Wagner, History of Cinema I (2024) at Jessica Silverman
$37,729: Annie Morris sculpture at Timothy Taylor
$37,500: Christopher Hartmann, Water Reflection 3 (2024) at Blum Gallery
$37,000: Rachel Eulena Williams, Deflecting Direction (2024) at Canada
$36,000: Atsushi Kaga, The Full Moon in October (2024) at Jessica Silverman
$36,000: Masako Miki, Spirited Fox Leading a Path Forward (2024) at Jessica Silverman
$35,000–$100,000: Two Robin Kid works at Templon, each
$35,000: Dorothy Dehner, Nauticus (1969) at Berry Campbell
$35,000: Alexandre da Cunha, Vitral (Den) (2024) at James Cohan
$35,000: Alec Egan, Lamp (2024) at Anat Ebgi
$35,000: McArthur Binion, summer:detroit (2024) at Gray
$35,000: Alexis Ralaivao, Satin (2024) at Kasmin
$35,000: Lee Jin-Woo, Untitled P 24-096 (2024) at Leeahn
$35,000: Tariku Shiferaw, You’re the One (SWV) (2023) at Galerie Lelong and Co.
$35,000: Five editions of a photograph by Diego Vega Solorza at Llano, total
$35,000: Wanda Koop, Moon Drop (2024) at Night Gallery
$35,000: Wanda Koop, Shoreline (2024) at Night Gallery
$35,000: Carroll Dunham, Land (1998) at David Nolan Gallery
$35,000: Mel Kendrick, Untitled (2024) at David Nolan Gallery
$35,000: Frida Orupabo, The Heavy Thinker (2024) at Galerie Nordenhake
$35,000: Sadie Barnette, Rich Man (2024) at Jessica Silverman
$35,000: Julia Chiang, Press On It Harder (2024) at Jessica Silverman
$35,000: Gabriel Orozco, 30.I.22 (a) #20 (2022) at White Cube
$34,000: Meeson Pae, Emerge (2024) at Anat Ebgi
$34,000: Kim Keun-Tai, Discussion 2023-60 (2023) at Leeahn
$33,000: Caleb Hahne Quintana, La Tierra Amarilla (2024) at Anat Ebgi
$32,000: Davide Balliano, UNTITLED_0306 (2024) at Cardi Gallery
$32,000: David Rappeneau, Untitled (2024) at Gladstone Gallery
$32,000: Oren Pinhassi, Truth Teller (2024) at Lehmann Maupin
$32,000: Chelsea Ryoko Wong, In Tandem (2024) at Jessica Silverman
$31,713: Hyun-Sook Song, 5 Brushstrokes (2019) at Sprüth Magers
$31,000: Cristina Canale, Queen (2024) at Nara Roesler
$30,000–$40,000: Paola Pivi, Untitled (pearls) (2023) at Perrotin
$30,000–$40,000: Keita Morimoto work at Almine Rech
$30,000–$40,000: Sylvia Ong work at Almine Rech
$30,000–$40,000: Reginald Sylvester II, Semi 008 (2024) at Canada
$30,000–$35,000: Mai-Thu Perret, She Conceals Herself in the Eye of the Needle (2024) at David Kordansky Gallery
$30,000: Two Sarah Meyohas pastels on paper at Marianne Boesky Gallery, each
$30,000–$50,000: Jennifer Tee work at Tina Kim Gallery
$30,000–$50,000: Daniel Gibson work at Almine Rech
$30,000: Denzil Hurley work at Canada
$30,000: Jose Alvarez D.O.P.A. work on paper at Gavlak
$30,000: Martha Diamond, Study for Facades (8) (1989) at David Kordansky Gallery
$30,000: Sam McKinniss, Roses (after Fantin-Latour) (2024) at David Kordansky Gallery
$30,000: Tariku Shiferaw, Liberated Skies (2024) at Galerie Lelong and Co.
$30,000: Michel Pérez Pollo, Lon (2024) at Mai 36 Galerie
$25,000-$65,000: Haas Brothers sculptures at Marianne Boesky Gallery
$25,000–$40,000: Vivian Greven, Ais VI (2024) at Perrotin
$20,000–$30,000: Ken Gun Min, Elegy to the Moon (Homage to Clair de Lune) (2024) at Nazarian / Curcio
$20,000–$30,000: Ken Gun Min, Night Walk in the Griffith Park (Homage to Korean Tiger) (2024) at Nazarian / Curcio
$20,000–$30,000: Ken Gun Min, Summer Night Walk (2024) at Nazarian / Curcio
$30,000: Michelle Blade, Studio Marigolds (2024) at Night Gallery
$30,000: Lucia Koch, Letter (2019) at Nara Roesler
$30,000: Sadie Barnette, Baby Boss (2024) at Jessica Silverman
$30,000: Woody De Othello, Bent (2024) at Jessica Silverman
$30,000: Woody De Othello, Inverse You (2024) at Jessica Silverman
$30,000: Woody De Othello, Small Shifts (2024) at Jessica Silverman
$30,000: Mire Lee, Open wound: Surface with many holes #1 (2024) at Sprüth Magers
$29,600: Mark Manders wall work at Xavier Hufkens
$28,000: Brian Rochefort, Panama (2022) at Massimo De Carlo
$28,000: Karyn Lyons, The Tale That Can’t Be Told (2024) at Anat Ebgi
$28,000: Mark Innerst, A Cloud Above First Avenue (1983) at Michael Kohn Gallery
$28,000: Mark Innerst, Tiffany (2017) at Michael Kohn Gallery
$28,000: Evan Holloway, February 2023 (2023) at David Kordansky Gallery
$28,000: Ryan Mrozowski, Untitled (Split Painting) (2024) at Galerie Nordenhake
$28,000: Woody De Othello, Gradual Change (2023) at Jessica Silverman
$27,696: Jin Han Lee, Day and Night Meet Twice a Day in the Morning and (2024) at Union Pacific
$27,696: Jin Han Lee, Keen Feet (2024) at Union Pacific
$26,532: Jaume Plensa, White Shadow V (2023) at Galerie Lelong and Co.
$26,361: Bram Demunter, Over the Boundless Land. Swift as the Blast of the Wind. (2024) at Tim Van Laere Gallery
$26,000: Jan-Ole Schiemann, You Are Here (2024) at Kasmin
$26,000: Nir Hod, I Want Everything That Does Not Exist (2024) at Michael Kohn Gallery
$25,000: Doki Kim, The Moon and Fire (2024) at Gallery Baton
$25,000: Betty Parsons, Untitled (1951) at Berry Campbell
$25,000: Hiroka Yamashita, MUI – Uchinaa Forest (2024) at Blum Gallery
$25,000: Thomas Houseago work on paper at Xavier Hufkens
$25,000: Tom Friedman, Back of Cap’n Crunch Box (2024) at Lehmann Maupin
$25,000: Bambou Gili, Avian Arc (2024) at Night Gallery
$25,000: Genesis Belanger, On Pause (2024) at Pace Gallery
$25,000: Karen Kilimnik, Keith (1979) at Sprüth Magers
$25,000: Richard Artschwager, Corner Splat II (2009) at Sprüth Magers
$25,000: John Waters, Fellini’s 8 1/2 (2014) at Sprüth Magers
$24,000: Liza Lacroix, If both of us were crawling after her, she’d be more important (2024) at Galerie Chantal Crousel
$24,000: Nir Hod, 100 Years is Not Enough (2024) at Michael Kohn Gallery
$24,000: Koenraad Dedobbeleer, Destroying the Past, Present and Future Too (2022) at Mai 36 Galerie
$24,000: Rodolfo Abularach, Halo – Eye No. 113 (1969–1970) at David Nolan Gallery
$24,000: Rodolfo Abularach, Esfera (1970) at David Nolan Gallery
$24,000: Elena Damiani, Unfoldings VIII (2023) at Galerie Nordenhake
$23,299: Jin Han Lee, Waiting for Night (2024) at Union Pacific
$23,299: Jin Han Lee, Our Time (2024) at Union Pacific
$23,255: Xavier Veilhan, Mobile nº 13 (2019) at Nara Roesler
$23,000: Tristan Unrau, Pose (2024) at David Kordansky Gallery
$22,000-$32,000: Three Thalita Hamaoui works at Marianne Boesky Gallery, each
$22,000: Asuka Anastacia Ogawa, Anjo (2024) at Blum Gallery
$22,000: Luke Murphy work at Canada
$22,000: Salvador Dalí, Sphinge with Body of Lion (1942) at Kasmin
$22,000: Hasani Sahlehe, Show Music (2024) at Night Gallery
$22,000: Hasani Sahlehe, Sisters (2024) at Night Gallery
$22,000: Ray Yoshida, Untitled (c. 1971–72) at David Nolan Gallery
$22,000: Sarah Crowner, Stone 3 Large (2024) at Galerie Nordenhake
$22,000: Sarah Crowner, Stone 2 Large (2024) at Galerie Nordenhake
$22,000: Herbert Gentry, Untitled (1964) at Ryan Lee
$21,000: Torbjørn Rødland, On the Table (2020) at David Kordansky Gallery
$20,000: Ranti Bam, Drakoni (2024) at James Cohan
$20,000–$30,000: Multiple Marlon Mullen works at Adams and Ollman, each
$20,000: Ranti Bam, Okuneda (2024) at James Cohan
$20,000: Ranti Bam, Yyaari (2024) at James Cohan
$20,000: Ranti Bam, (Four-leg) Black Ifa (2024) at James Cohan
$20,000: Soumya Netrabile, A Hole in the Forest (2024) at Anat Ebgi
$20,000: Krzysztof Strzelecki, Waters of Life (2024) at Anat Ebgi
$20,000: Camille Henrot, Shampoo (2022) at Hauser and Wirth
$20,000: Jimmy Ernst, Untitled (blue-white) (1954) at Kasmin
$20,000: Tariku Shiferaw, Getting Late (Syd) (2022) at Galerie Lelong and Co.
$20,000: Jack Warne, Illy nad Ulcy In The Lingddap Pool (2024) at Mai 36 Galerie
$20,000: Thiago Barbalho Xaxado, tea (2023) at Nara Roesler
$20,000: Woody De Othello, Set Forth First with Imagination (2024) at Jessica Silverman
$20,000: Michel Pérez Pollo painting at Timothy Taylor
$19,536: Elena Alonso, Capa verde agua (2024) at Fabian Lang and Espacio Valverde
$19,000: Paul Jenkins drawing at Timothy Taylor
$18,400–$21,600: Elena Alonso, Kind and Sharp, 14 (2024) at Fabian Lang and Espacio Valverde
$18,400–$21,600: Elena Alonso, Kind and Sharp, 16 (2024) at Fabian Lang and Espacio Valverde
$18,400–$21,600: Elena Alonso, Kind and Sharp, 17 (2024) at Fabian Lang and Espacio Valverde
$18,000: Hasani Salahe work at Canada
$18,000: Ranti Bam, Laawo (2024) at James Cohan
$18,000: Jordan Nassar, Beyond the Fog (2024) at James Cohan
$18,000: Ricky Swallow, Mitered Form with Shells (2024) at David Kordansky Gallery
$18,000: Herbert Gentry, Untitled – Red Brown at Ryan Lee
$18,000: Elian Almeida, O Rio de Tia Ciata (2024) at Nara Roesler
$18,000: Masako Miki, Cat Shapeshifter and the Galaxy Radiate Energy (2024) at Jessica Silverman
$18,000: Masako Miki, Plaster Wall Spirit and Fox Deity Foresee a Path Forward (2024) at Jessica Silverman
$18,000: Desire Moheb-Zandi tapestry at Wentrup
$17,500: Gideon Rubin, Untitled (2024) at Anat Ebgi
$17,000: Emma Cousin, Pike (2024) at Jessica Silverman
$16,914–$126,852: Five Chiharu Shiota works at Templon, each
$16,000–$80,000: Ferrari Sheppard, Venice (2024) at Massimo De Carlo
$16,000–$80,000: Aaron Garber-Maikovska, Cyprus (2024) at Massimo De Carlo
$16,000–$80,000: Stephanie Temma Hier, Ghosts in the Doorways (2024) at Massimo De Carlo
$16,000–$80,000: Stephanie Temma Hier, Time We Talked Again (2024) at Massimo De Carlo
$16,000: Tromarama, Auto Ally (2024) at Document
$16,000: Hasani Sahlehe, West (2024) at Night Gallery
$15,000–$20,000: Mire Lee work at Tina Kim Gallery
$15,000: Jessica Taylor Bellamy, Redact & Recline (2024) at Anat Ebgi
$15,000: Krzysztof Strzelecki, Group Shower (2024) at Anat Ebgi
$15,000: Jared Buckhiester, The Slattery’s Tree (2024) at David Kordansky Gallery
$15,000: Van Hanos, Lifestyle (2024) at Lisson Gallery
$15,000: Rodolfo Abularach, Paojo (1983) at David Nolan Gallery
$15,000: Sarah Crowner, Stone 1 Small (2024) at Galerie Nordenhake
$15,000: Ryan Mrozowski, Untitled (Nocturne) (2024) at Galerie Nordenhake
$15,000: Claudia Wieser, Untitled (2024) at Jessica Silverman
$15,000: Patrick Martinez sculpture at Timothy Taylor
$14,500: Zhu Jinshi, The Way of Great Generals 2, Stratagem (2022) at Blum Gallery
$14,500: William Brickel, Hand on His Chest (2024) at Michael Kohn Gallery
$14,000-$20,000: Franz Kline works on paper at Hirschl and Adler, each
$14,000: Alexander Harrison, Untitled (2024) at Kasmin
$14,000: Sadie Barnette, More Alive (Rainbow) (2024) at Jessica Silverman
$13,000: Carroll Dunham, Untitled (7/24/09) (2009) at David Nolan Gallery
$13,000: Carroll Dunham, Untitled (9/22/09) (2009) at David Nolan Gallery
$12,744: Christine Safa, Tournesols (2024) at Galerie Lelong and Co.
$10,571: Anne Imhof, Untitled (Riders series) (2024) at Sprüth Magers
$10,500: Alicia Adamerovich drawing at Timothy Taylor
$10,000–$25,000: Tania Perez Cordova work at Tina Kim Gallery
$10,000–$20,000: Four Melissa Joseph pieces at Charles Moffett Gallery, each
$10,000–$20,000: Two Kris Knight paintings Gavlak, combined
$10,000: Agata Słowak, Your Woman is a Medusa (2024) at Blum Gallery
$10,000: Susan Chen, The Sun Fell Into the Sea (2024) at Night Gallery
$10,000: Susan Chen, Low Tide (2024) at Night Gallery
$10,000: Jimena Croceri, Impossible Jewel Series (2024) at Piedras
$10,000: Jimena Croceri, Impossible Jewel Series (2024) at Piedras
$10,000: Julieta Tarraubella, The Secret Life of Flowers | Surveillance Center (2024) at Rolf Art, multiple editions, each
$9,500: Gideon Rubin, Untitled (2024) at Anat Ebgi
$9,000: Jimena Croceri, Impossible Jewel Series (2024) at Piedras
$8,500: Paul Mpagi Sepuya, Sitting for Jack (P1270836) (2023) at Document
$8,500: Sandra Vásquez de la Horra, Playgirls Don’t Play Longer (2010) at David Nolan Gallery
$8,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#9_White Lilies (2024) at Rolf Art, multiple editions, each
$8,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#11_Pink Lilies & Tulips (2024) at Rolf Art
$8,496: Christine Safa, Fleurs (2023) at Galerie Lelong and Co.
$8,457–$10,571: Elena Alonso, Chapado (2022) at Fabian Lang and Espacio Valverde
$8,449–$10,561: Five Tarek Lakhrissi works at Galerie Allen, each
$8,000–$10,000: Elena Alonso, Untitled (Kind and Sharp, 25) (2024) at Fabian Lang and Espacio Valverde
$8,000: Gideon Rubin, Untitled (2024) at Anat Ebgi
$8,000: Emil Sands, Airport Smoking Area (2024) at Kasmin
$8,000: Ben Tong, Flower’s in Glass of Water (2024) at Night Gallery
$8,000: Jimena Croceri, Impossible Jewel Series (2024) at Piedras
$8,000: Jimena Croceri, Impossible Jewel Series (2024) at Piedras
$8,000: Jimena Croceri, Impossible Jewel Series (2024) at Piedras
$7,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#6_Orange Lilies (2024) at Rolf Art, multiple editions, each
$7,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#7_Lilies (2024) at Rolf Art, multiple editions, each
$7,000–$35,000: Four Kim Dacres sculptures at Charles Moffett Gallery, each
$7,000: Shannon Ebner work at Kaufmann Repetto
$7,000: Ficre Ghebreyesus, Untitled (c.2002–08) at Galerie Lelong and Co.
$6,500: Spencer Finch, Sunset in a Cup (2024) at James Cohan
$6,500: Spencer Finch, Sunset in a Cup (2024) at James Cohan
$6,500: Spencer Finch, Sunset in a Cup (2024) at James Cohan
$6,500: Rachel Youn, Taste (2024) at Night Gallery
$6,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#4_Lisianthus & Lilies (2024) at Rolf Art, multiple editions, each
$6,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#5_Lilies & Saffron (2024) at Rolf Art, multiple editions, each
$6,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#8_Tulips & Lilies (2024) at Rolf Art, multiple editions, each
$6,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#10_Persian Buttercups, Tulips & Daffodils (2024) at Rolf Art, multiple editions, each
$6,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#15_Roses & Aloe Vera (2024) at Rolf Art, multiple editions, each
$6,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#13_Anemones, Tulips & Persian Buttercups (2024) at Rolf Art
$6,000–$25,000: Terrence Musekiwa, Chifamba nezvanza (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Muni (visitor) (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Mupitikiri (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Werudzi (one of us) (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Rooted (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Murwi (warrior) (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Muera nungu (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Muera nungu 2 (Sikarudzi) (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Chawazi (2024) at Catinca Tabacaru
$6,000–$25,000: Terrence Musekiwa, Mumwe werudzi (2024) at Catinca Tabacaru
$6,000: Kate Shepherd, Popsicle (2024) at Galerie Lelong and Co.
$5,500: Rachel Youn, Urge (2024) at Night Gallery
$5,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#2_Peonies (2024) at Rolf Art, multiple editions, each
$5,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#3_Tulips (2024) at Rolf Art, multiple editions, each
$5,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#12_Daffodils, Tulips & Persian Buttercups (2024) at Rolf Art
$5,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#14_Lilies (2024) at Rolf Art, multiple editions, each
$5,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#17_Persian Buttercups (2024) at Rolf Art, multiple editions, each
$5,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#18_Anemones (2024) at Rolf Art, multiple editions, each
$5,000: Keita Morimoto, Silent Light (2024) at Night Gallery
$4,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#1_Iris (2024) at Rolf Art, multiple editions, each
$4,500: Julieta Tarraubella, The Secret Life of Flowers | Garden_#16_Sunflowers (2024) at Rolf Art, multiple editions, each
$4,000–$6,000: Mikael Lo Presti, Sardine/Flowers (2024) at Galerie Frank Elbaz
`;